module.exports = __webpack_public_path__ + "@/assets/img/repayment-mobile.f143c07f.png";